/** Supported country calling codes for phone profile collection. */
export const PHONE_COUNTRIES = [
  { code: 'IN', label: 'India', dial: '+91', flag: '🇮🇳', digits: 10 },
  { code: 'US', label: 'United States', dial: '+1', flag: '🇺🇸', digits: 10 },
  { code: 'GB', label: 'United Kingdom', dial: '+44', flag: '🇬🇧', digits: 10 },
  { code: 'AE', label: 'United Arab Emirates', dial: '+971', flag: '🇦🇪', digits: 9 },
];

export function getCountryByCode(code) {
  return PHONE_COUNTRIES.find((c) => c.code === code) || PHONE_COUNTRIES[0];
}

export function validateNationalPhone(countryCode, nationalNumber) {
  const country = getCountryByCode(countryCode);
  const digits = String(nationalNumber || '').replace(/\D/g, '');
  if (!digits) {
    return { ok: false, error: 'Phone number is required' };
  }
  if (country.digits && digits.length !== country.digits) {
    return {
      ok: false,
      error: `Enter a valid ${country.digits}-digit number for ${country.label}`,
    };
  }
  return { ok: true, digits };
}

export function formatCountryOption(country) {
  return `${country.flag} ${country.dial}`;
}

export function formatPhonePreview(countryCode, nationalNumber) {
  const country = getCountryByCode(countryCode);
  const digits = String(nationalNumber || '').replace(/\D/g, '');
  if (!digits) return '';
  return `${country.dial} ${digits}`;
}

/**
 * Split a stored E.164 phone (e.g. +919448321841) into the matching supported
 * country code and the local national number (9448321841) for form prefill.
 * Never slices the first local digit: the dial code is matched explicitly
 * against known dial codes (longest first), never via a greedy regex.
 */
export function splitE164Phone(e164) {
  const digits = String(e164 || '').replace(/\D/g, '');
  if (!digits) return { countryCode: 'IN', local: '' };
  const candidates = [...PHONE_COUNTRIES].sort((a, b) => b.dial.length - a.dial.length);
  for (const country of candidates) {
    const dialDigits = country.dial.replace('+', '');
    if (digits.startsWith(dialDigits)) {
      const local = digits.slice(dialDigits.length);
      if (local && (!country.digits || local.length === country.digits)) {
        return { countryCode: country.code, local };
      }
    }
  }
  return { countryCode: 'IN', local: digits };
}

/** Strip the dial code of `countryCode` from a stored E.164 phone. */
export function localPhoneFromE164(e164, countryCode = 'IN') {
  return splitE164Phone(e164).local;
}

